import { FieldMessage as ChordsFieldMessage } from '~/chords/FieldMessage';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FieldMessage = withClassNameHoc(ChordsFieldMessage);
